module.exports = __webpack_public_path__ + "static/media/CSV_import_template.28b0c300.csv";